import { siteInfo } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[620px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[500px] h-[500px] md:w-[700px] md:h-[700px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] md:w-[550px] md:h-[550px] bg-accent-100/25 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="w-full flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              {siteInfo.tag}
            </span>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 font-heading leading-tight mb-4">
              菲菲影院
              <span className="block text-primary-500 mt-1">
                电视剧全集免费在线观看
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-4">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-6">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-7">
              {siteInfo.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-xl md:text-2xl font-black text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-0.5">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap no-underline"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追剧
              </a>
              <a
                href="#index"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg border-2 border-background-300 text-foreground-700 font-semibold text-sm md:text-base hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap no-underline"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-grid-line text-lg"></i>
                浏览剧集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[420px] lg:max-w-[480px]">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-400/20 to-accent-400/20 rounded-3xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20drama%20collage%20featuring%20various%20popular%20TV%20series%20scenes%2C%20cinematic%20montage%20style%2C%20warm%20golden%20and%20crimson%20lighting%2C%20dramatic%20composition%2C%20entertainment%20and%20film%20aesthetic%2C%20rich%20vibrant%20colors%2C%20modern%20streaming%20platform%20visual&width=800&height=600&seq=hero-main&orientation=landscape"
                alt="菲菲影院 - 海量电视剧免费在线观看"
                className="relative w-full h-auto rounded-2xl object-cover aspect-[4/3]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}